import type { CurrencyCode, Money } from './types';

const MINOR_UNITS_PER_MAJOR: Record<CurrencyCode, number> = {
  AUD: 100,
  USD: 100,
  NZD: 100,
  GBP: 100,
  EUR: 100,
  CAD: 100,
};

/** Mirrors packages/shared's formatMoney - duplicated locally since this app renders money in
 * many list/detail screens and that package isn't wired as a dependency here. Display only. */
export function formatMoney(m: Money, locale = 'en-AU'): string {
  const divisor = MINOR_UNITS_PER_MAJOR[m.currency];
  return new Intl.NumberFormat(locale, { style: 'currency', currency: m.currency }).format(
    m.amountMinor / divisor,
  );
}

export function formatMinor(amountMinor: number, currency: CurrencyCode, locale = 'en-AU'): string {
  return formatMoney({ amountMinor, currency }, locale);
}

export function formatDateTime(epochMs: number | null | undefined, timezone?: string): string {
  if (epochMs === null || epochMs === undefined) return '-';
  return new Intl.DateTimeFormat('en-AU', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: timezone,
  }).format(new Date(epochMs));
}

export function formatDate(epochMs: number | null | undefined): string {
  if (epochMs === null || epochMs === undefined) return '-';
  return new Intl.DateTimeFormat('en-AU', { dateStyle: 'medium' }).format(new Date(epochMs));
}

export function toEpochMs(datetimeLocalValue: string): number {
  return new Date(datetimeLocalValue).getTime();
}

export function fromEpochMsToInputValue(epochMs: number | null | undefined): string {
  if (!epochMs) return '';
  const d = new Date(epochMs);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
